import React from 'react';

function CardiologyExamsLabLogin() {
    return (
        <div>
        <h1>Cardiology Exams Lab Login</h1>
        {/* Contenido de la página */}
        </div>
    );
}

export default CardiologyExamsLabLogin;
